import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { angleUp } from '@primeicons/core/angle-up';

@Component({
    selector: 'svg[data-p-icon="angle-up"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class AngleUp extends CoreIcon {
    constructor() {
        super();
        this._icon = angleUp;
    }
}
